import axios from 'axios';

export const getAlbumData = async ({ metaSiteId, setId }) => {
  const dbUrl = 'https://albums-c06a.restdb.io/rest';
  const apiKey = '5cdd63693b66915f6881f8b0';
  const instance = axios.create({
    baseURL: dbUrl,
    headers: { 'Content-Type': 'application/json', 'x-apiKey': apiKey },
  });

  const query = setId ? `{"setId":"${setId}"}`: `{"metaSiteId":"${metaSiteId}"}`
  const result = await instance.get(`/albums?q=${query}`);
  console.log({result})
  // const result = await axios.get(`https://www.wix.com/_api/albums-node-server/album?metaSiteId=${metaSiteId}`)

  return result.data[0];
}
